import React from 'react'
import { shallow, mount } from 'enzyme'
import StaticTables from '../StaticTables'
import BalanceSheet from '../BalanceSheet'
import MarginAnalysis from '../MarginAnalysis'
import LoanPayments from '../LoanPayments'
import business from './testData/business'
import years from './testData/years'

describe('<StaticTables />', () => {
  let props, wrapper
  beforeEach(() => {
    props = {
      rid: 5467,
      name: 'Business Business',
      entity: business,
      years,
      hasExistingDebt: true,
      debtSchedulePending: false,
      resourceType: 'Business',
      useOfFund: {
        businessAcquisition:         100,
        hiring:                      200,
        inventory:                   4000,
        marketing:                   4943,
        newEquipment:                4248,
        operationalCosts:            48284,
        realEstateMortgageRefinance: 49384,
        realEstatePurchase:          4842,
        refinance:                   48484,
        remaining:                   48492,
        total:                       484290
      },
      guarantors: business.guarantors
    }
    wrapper = shallow(
      <StaticTables {...props} />
    )
  })

  it('renders without crashing', () => {
    shallow(<StaticTables {...props} />)
  })
  it('renders a warning message if the use of proceeds is incorrect', () => {
    expect(wrapper.find('#use_of_proceeds_notification').length).toEqual(1)
  })
  it('does not render a warning message if the use of proceeds total is zero (indicating that it has not been modified', () => {
    const mockedUseOfFund = {
      businessAcquisition:         0,
      hiring:                      0,
      inventory:                   0,
      marketing:                   0,
      newEquipment:                0,
      operationalCosts:            0,
      realEstateMortgageRefinance: 0,
      realEstatePurchase:          0,
      refinance:                   0,
      remaining:                   0,
      total:                       0
    }
    const wrapper = shallow(<StaticTables {...props} useOfFund={mockedUseOfFund} />)
    expect(wrapper.find('#use_of_proceeds_notification').length).toEqual(0)
  })
  it('renders a <MarginAnalysis /> if its resourceType is \'Business\'', () => {
    expect(wrapper.find(MarginAnalysis).length).toEqual(1)
  })
  it('does not render a <MarginAnalysis /> if its resourceType is something other than business', () => {
    // Shallow render so child components don't run queries on mount (they will fail because there is no ApolloProvider)
    const wrapper = shallow(<StaticTables {...props} entity={business.guarantors[0]} resourceType="Guarantor" />)
    expect(wrapper.find(MarginAnalysis).length).toEqual(0)
  })
  it('renders a <LoanPayments /> if the resourceType is \'Guarantor\'', () => {
    const wrapper = shallow(<StaticTables {...props} entity={business.guarantors[0]} resourceType="Guarantor" />)
    expect(wrapper.find(LoanPayments).length).toEqual(1)
  })
  it('renders a <BalanceSheet /> if the provided entity has one', () => {
    // The guarantor in the test data has a balance sheet
    const wrapper = shallow(<StaticTables {...props} entity={business.guarantors[0]} resourceType="Guarantor" />)
    expect(wrapper.find(BalanceSheet).length).toEqual(1)
  })
  it('does not render a <BalanceSheet /> if the provided entity does not have one', () => {
    expect(wrapper.find(BalanceSheet).length).toEqual(0)
  })
  describe('#renderBalanceSheet', () => {
    it('returned BalanceSheet contains taxesOwed', () => {
      const wrapper = shallow(<StaticTables {...props} entity={business.guarantors[0]} resourceType="Guarantor" />)
      const object = wrapper.instance().renderBalanceSheet()
      expect(JSON.stringify(object)).toContain('taxesOwed')
    })
  })
})
